import { questionLogicOperators } from '@api/surveys';

export const answerOperators = [questionLogicOperators.ANY, questionLogicOperators.NOT];

export const LOGIC_OPTIONS = {
  ANSWER: { text: 'Answer', value: 'answer' },
  QUOTA_GROUP: { text: 'Quota Group', value: 'quotaGroup' },
};
export const availableLogicOptions = [LOGIC_OPTIONS.ANSWER, LOGIC_OPTIONS.QUOTA_GROUP];

export const numericLogicOperators = [
  questionLogicOperators.EQUALS,
  questionLogicOperators.GREATER_THAN,
  questionLogicOperators.GREATER_THAN_OR_EQUAL,
  questionLogicOperators.LESS_THAN,
  questionLogicOperators.LESS_THAN_OR_EQUAL,
];

export const quotaGroupRef = 'quota_group_ref';

export const skipOperators = [questionLogicOperators.ALL, questionLogicOperators.ANY];
